import React from 'react';
import { components } from 'react-select';
import { XIcon } from '@pattern-library/icon';
const SearchIndicatorsContainer = props => {
  // eslint-disable-next-line react/prop-types
  const {
    children,
    clearValue,
    hasValue,
    selectProps: {
      inputValue
    }
  } = props;

  // Purpose: show a custom clear button when the text input has a value,
  // but an option has not been selected, and when there is not a loading event
  const showClearButton = Boolean(inputValue) && !hasValue;
  return /*#__PURE__*/React.createElement(components.IndicatorsContainer, props, children, showClearButton && /*#__PURE__*/React.createElement("button", {
    className: "asc-select-clear-button",
    type: "button",
    onClick: clearValue
  }, /*#__PURE__*/React.createElement(XIcon, {
    className: "asc-select-clear-x",
    size: "xxs",
    color: "dark-gray",
    label: "Clear"
  })));
};
export default SearchIndicatorsContainer;